import { render, staticRenderFns } from "./leaflet-map-polygon-edit.vue?vue&type=template&id=6b607525"
import script from "./leaflet-map-polygon-edit.vue?vue&type=script&lang=ts"
export * from "./leaflet-map-polygon-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b607525')) {
      api.createRecord('6b607525', component.options)
    } else {
      api.reload('6b607525', component.options)
    }
    module.hot.accept("./leaflet-map-polygon-edit.vue?vue&type=template&id=6b607525", function () {
      api.rerender('6b607525', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flightpath-components/lib-components/leaflet-map-polygon-edit.vue"
export default component.exports